// extracted by mini-css-extract-plugin
module.exports = {"app_paragraph":"AppParagraph_app_paragraph__2_0S9"};